import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <main className="flex min-h-screen flex-col items-center justify-center bg-background-secondary px-4 text-center text-text-primary">
    <h1 className="text-4xl font-bold sm:text-5xl">404 — Page Not Found</h1>
    <p className="mt-4 max-w-xl text-lg text-text-secondary">
      The page you were looking for is missing or has moved. Head back to continue
      exploring ForecastHQ.
    </p>
    <Link
      to="/"
      className="mt-8 inline-flex items-center justify-center rounded-md bg-interactive-primary px-6 py-3 text-base font-medium text-white shadow-sm transition hover:bg-interactive-primary-hover focus:outline-none focus:ring-2 focus:ring-interactive-primary focus:ring-offset-2"
    >
      Return to Landing Page
    </Link>
  </main>
);

export default NotFoundPage;
